import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding-top: 30px;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 400px;
`;

export const Paper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    border: 1px solid #333;
    box-shadow: 0 3px 5px rgba(0,0,0,0.3);
    width: calc(100% - 60px);
    background-color: #262626;
    margin-bottom: 50px;

    &.charsheet:last-child {
        margin-bottom: 0;
    }
`;

export const PaperRatio = styled.div`
    width: 100%;
    padding-bottom: 141.42%;
    position: relative;
`;

export const PaperContent = styled.div`
    position: absolute;
    box-sizing: border-box;
    top: 5.0505%;
    left: 7.1428%;
    right: 7.1428%;
    bottom: 5.0505%;
    border: 1px solid #333;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;

    &.no-border {
        border: 0px;
    }
`;

export const ContentRender = styled.div`
    display: grid;
    grid-template-columns: repeat(${props => props.cols || 36},1fr);
    grid-template-rows: repeat(${props => props.rows || 52},1fr);
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
`;

export const ContentGrid = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 3;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
`;